var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "_flexcntr _flexaicntr _tc--lighter gfu-bt gfu-bt--overline",
    },
    [
      _vm._v("\n    payments powered by "),
      _c("base-image", {
        staticClass: "_ml-1",
        attrs: { src: "/content/images/payments/logo-adyen.png", alt: "Adyen" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }